(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {

		/* Search in the header */
		const $search = $('.header-search-icon-wrapper button, .close-search-overlay, .mobile-search-toggle button');

		$search.on('click', function(){

			$('body').toggleClass('search-is-active');

			if	($('body').hasClass('search-is-active')) {
				$('.search-form .form-item input').focus();
			}
		});
	});
})(jQuery);
